import { render, staticRenderFns } from "./ProductionUnits.vue?vue&type=template&id=17b2ac70&scoped=true&"
import script from "./ProductionUnits.vue?vue&type=script&lang=js&"
export * from "./ProductionUnits.vue?vue&type=script&lang=js&"
import style0 from "./ProductionUnits.vue?vue&type=style&index=0&id=17b2ac70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2ac70",
  null
  
)

export default component.exports